
import styled from "styled-components";
import theme from "./../../styles/theme"

export const BrandsSection = styled.section`
  padding: 40px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const LogosBoxCarousel = styled.div`
  padding: 40px 0px;
  @media (max-width:  ${theme.breakpoints.medium}) {
    padding: 25px 0px 50px;
  }
`;

export const BrandsBoxTextsContent = styled.div`
  background: ${theme.colors.black};
  padding: 40px 80px 80px;

  @media (max-width:  ${theme.breakpoints.medium}) {
    padding: 20px 40px 40px;

    h2{
      font-size: ${theme.fontSizes.medium};
      line-height: 22px;
      font-weight: ${theme.fontWeights.bold};
    }
  }

`;

export const BrandsBoxTexts = styled.div`
  text-align: left;
  width: 100%;

  div{
    align-items: baseline;
  }

  h3{
    width: 60%;

    @media (max-width:  ${theme.breakpoints.medium}) {
      width: 100%;
      font-size: ${theme.fontSizes.medium};
      line-height: 26px;
      padding-top: 30px;
    }
  }
`;

export const BrandsBoxCarousel = styled.div`
  padding: 20px;
  width: 1300px;

  @media (max-width: 600px) {
    display: flex;
    justify-content: center;
  }

  @media (max-width: 1200px) {
    width: 100%;
  }
  .slick-next {
    @media (max-width:  ${theme.breakpoints.medium}){
      right: 0px!important;
      path{
          fill: white;
      }
      &:hover{
        background:  ${theme.colors.landingTheme};

        path{
          fill: white!important;
        }
      }
    }
  }
  .slick-prev{
    @media (max-width:  ${theme.breakpoints.medium}){

      .ArrowRecogbition{
        background-color:  ${theme.colors.landingTheme};
        path{
          fill: white;
        }
      }
    }
  }

  .slick-dots{
    width: 100%;
    display: flex!important;
    justify-content: center;

    li{
      border-radius: 5px;
      width: 100%;
      height: 5px;
      margin: 0;

      button{
        width: 100%;

        &:before{
          content: '';
          width: 100%;
          background: #C4C4C4;
          font-family: none;
          transition: font-size .3s ease;
          height: 5px;
        }
      }
    }
    li.slick-active{
      button{
          &:before{
            content: '';
            width: 100%;
            background: black;
            font-family: none;
          }
        }
      }
    }

  .ArrowRecogbition{
    padding: 10px;
    border-radius: 100%;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-transition: .3s ease;
    -moz-transition: .3s ease;
    -o-transition: .3s ease;
    transition: .3s ease;

    @media (max-width:  ${theme.breakpoints.medium}){
      background:  ${theme.colors.landingTheme};
      width: 35px;
      height: 35px;
      svg{
        width: 8px;
      }
    }
    &:hover{
      background:  ${theme.colors.landingTheme};

      path{
        fill: white!important;
      }
    }
  }
  .slick-next {
    top: 95%;
    right: -20px;

    @media (max-width:  ${theme.breakpoints.medium}){
      left: 305px;
      top: -25px;
      width: 35px;
      height: 35px;
      border-radius: 50%;

      ::before{
        display: none;
      }
    }
  }
  .slick-prev{
    top: 95%;
    left: -20px;

    @media (max-width:  ${theme.breakpoints.medium}){
      left: 260px;
      top: -25px;
      width: 35px;
      height: 35px;
      border-radius: 50%;
      ::before{
        display: none;
      }
    }
  }
  .slick-slider {
    @media (max-width: 600px) {
      max-width: 360px;
    }

  }
  .slick-initialized .slick-slide{
    display: flex;
    justify-content: center;
  }
  .slick-track{
    display: flex;
    /* align-items: center; */

    @media (max-width: 768px) {
      align-items: flex-start;
    }
  }
  .slick-slide.slick-active.slick-current{
    .descriptionwrapper{
      background: ${theme.colors.white};
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12);
      border-radius: 5px;
      width: 360px;
      height: min-content;

      img{
        filter: grayscale(0);
      }

      .slick-slider{
        margin: 0;
      }

      ul{
        bottom: -12%;
        width: 100%!important;
        display: flex!important;
        justify-content: center;

        li{
          border-radius: 5px;
          width: 100%;
          height: 5px;
          margin: 0;

          button{
            width: 100%;

           &:before{
              content: '';
              width: 100%;
              background: #C4C4C4;
              font-family: none;
              transition: font-size .3s ease;
           }
          }
        }
        li.slick-active{
          button{
              &:before{
                content: '';
                width: 100%;
                background: black;
                font-family: none;
                border-radius: 0px 0px 5px 5px;
              }
            }
          }
        }
      }
    }
  .slick-slide{
    margin-top: 50px;

    &.slick-current {
      margin-top: 0;
    }
    .slick-arrow.slick-next{
      font-size: ${theme.fontSizes.small};
      line-height: 22px;
      font-weight: 600;
      color: black;
      width: 200px;
      height: 100%;
      text-align: inherit;
      display: flex;
      justify-content: center;
      align-items: end;
      top: 58%;
      gap: 5px;

      div{
        width: 6%;
        padding-bottom: 4px;
      }
    }

    .descriptionwrapper{
      background: ${theme.colors.white};
      border: 1px solid rgba(225, 225, 225, 0.3);
      box-sizing: border-box;
      border-radius: 5px;
      width: 290px;
      height: min-content;

      .slick-netx{
        font-size: ${theme.fontSizes.small};
        line-height: 22px;
        color: black;
      }

      img{
        filter: grayscale(.75);
      }
      .slick-slider{
        margin: 0;
      }
      ul{
        border-radius: 5px;
        bottom: -12%;
        width: 100%!important;
        display: flex!important;
        justify-content: center;

        li{
          width: 100%;
          height: 5px;
          margin: 0;

          button{
            width: 100%;

           &:before{
              content: '';
              width: 100%;
              background: #C4C4C4;
              font-family: none;
              transition: font-size .3s ease;
           }
          }
        }
        li.slick-active{
          button{
              &:before{
                content: '';
                width: 100%;
                background: black;
                font-family: none;
              }
            }
          }
        }
    }
  }
`;
